import { IconBackhoe } from "@tabler/icons-react";
import { addMinutes, formatDistanceToNowStrict, isAfter } from "date-fns";

export default function MaintenancePage({
  maintenanceEndsAt,
}: {
  maintenanceEndsAt?: string;
}) {
  const endsAt = maintenanceEndsAt ? new Date(maintenanceEndsAt) : null;
  const showEta = endsAt && isAfter(endsAt, addMinutes(new Date(), 5));
  const eta = showEta
    ? formatDistanceToNowStrict(endsAt, { addSuffix: false })
    : null;

  return (
    <div className="flex h-full w-full flex-col items-center justify-center px-5 py-12">
      <div className="flex-1"></div>
      <IconBackhoe size={72} stroke={1.5} />
      <h1 className="mt-2 text-xl font-bold">
        Amplifiles Studio is under maintenance
      </h1>
      <p className="mt-1 max-w-md text-center text-text-secondary">
        We are deploying new features and will be back online soon. Thank you
        for your patience.
      </p>
      {eta && (
        <p className="mt-3 text-sm text-text-secondary">
          Estimated time remaining: ~{eta}
        </p>
      )}
      <div className="flex-1"></div>
      <div className="">
        <a href="https://amplifiles.ai">
          <img
            src="/AmplifilesLogo.png"
            alt="Amplifiles Logo"
            className="h-8"
          />
        </a>
      </div>
    </div>
  );
}
